export default __webpack_public_path__ + "static/media/landing4.e0879ae6.png";